export default "__VITE_ASSET__9p7iD3gn__"